/* eslint-disable no-use-before-define */
import React from 'react'
import kebabCase from 'lodash/kebabCase'
import NavigationItem from './NavigationItem'
import Store from './Store'
import styles from './styles.module.scss'

const Stores = ({ stores, storeToShow, setStoreToShow }) => {
  const selectedStore =
    stores?.find(item => kebabCase(item.displayName) === storeToShow) || stores[0]

  return (
    <div className={styles.stores}>
      <h1 className={styles.stores__header}>Stores</h1>
      <h2 className={styles.stores__subheader}>
        Find one of our {stores?.length || '11'} stores nearest you.
      </h2>

      <nav className={styles.stores__nav}>
        {stores?.length > 0 &&
          stores.map((s, i) => (
            <NavigationItem
              key={kebabCase(s.displayName)}
              index={i}
              store={s}
              permalink={kebabCase(s.displayName)}
              storeToShow={storeToShow}
              setStoreToShow={setStoreToShow}
            />
          ))}
      </nav>

      <Store store={selectedStore} />
    </div>
  )
}

export default Stores
